//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dialogMixin from '@/mixin/dialog.js';
import { validNumber } from '@/utils/validation.js';

export default {
  name: 'FamilyAdd',
  mixins: [dialogMixin],
  props: {
    updatePageData: { type: Function, default: () => {} },
    isEdit: { type: Boolean, default: false },
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      loadingBtn: false,
      addForm: {
        name: null,
        department: null,
        status: null,
        startDate: '',
        endDate: '',
      },
      rules: {
        familyName: [
          { required: true, message: '請輸入姓名', trigger: 'blur' },
        ],
        familyTitle: [
          { required: true, message: '請輸入稱謂', trigger: 'blur' },
        ],
        familyAge: [{ validator: validNumber, trigger: 'blur' }],
      },
    };
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '編輯家庭成員' : '新增家庭成員';
    },
  },
  methods: {
    handleAddFamily(payload) {
      this.$api('userAddFamily', payload).then(() => {
        this.$message.success('新增成功!');
        this.updatePageData();
      });
    },
    handleEditFamily(payload) {
      this.$api('userUpdateFamily', payload).then(() => {
        this.$message.success('編輯成功!');
        this.updatePageData();
      });
    },
    onSave() {
      this.$refs['addForm'].validate(valid => {
        if (!valid) {
          return null;
        }
        const payload = Object.assign({}, this.addForm);

        if (this.isEdit) {
          this.handleEditFamily(payload);
        } else {
          this.handleAddFamily(payload);
        }
        this.close();
      });
    },
    onClose() {
      this.$refs.addForm.resetFields();
      this.close();
    },
    onOpen() {
      this.addForm = Object.assign({}, this.item);
    },
  },
};
